// extracted by mini-css-extract-plugin
export var border = "_i-7";
export var brand = "_i-r";
export var button = "_i-j";
export var center = "_i-9";
export var centered = "_i-5";
export var closeButton = "_i-b";
export var disabledWrapper = "_i-k";
export var error = "_i-n";
export var extraLarge = "_i-4";
export var extraSmall = "_i-1";
export var fill = "_i-g";
export var footer = "_i-f";
export var footerAction = "_i-h";
export var footerButtons = "_i-i";
export var header = "_i-6";
export var icon = "_i-m";
export var info = "_i-q";
export var inline = "_i-8";
export var large = "_i-3";
export var main = "_i-c";
export var modal = "_i-0";
export var neutral = "_i-s";
export var noPadding = "_i-e";
export var none = "_i-t";
export var scrollable = "_i-d";
export var small = "_i-2";
export var success = "_i-p";
export var tight = "_i-l";
export var titleIcon = "_i-a";
export var warn = "_i-o";